// TODO PendingToReceive: restore comment and delete actual fn when PendingToReceive EP is ready
export const hasPendingToReceiveOrders = pendingOrders => !!pendingOrders
// export const hasPendingToReceiveOrders = pendingOrders =>  parseInt(pendingOrders, 10) > 0
